import { FilterToggle } from "./FilterToggle";
import OpSelect from "../OpSelect/OpSelect";
import "./Controls.scss";
import { colors } from "./colors";
import { useEffect, useRef } from "react";
import debounce from "lodash/debounce";

export function Controls({
	updateSort,
	updateFilters,
	sort,
	filters = {},
	sortOptions = [],
	setControlsHeight,
}) {
	const ref = useRef();
	useEffect(() => {
		if (setControlsHeight) {
			let rect = ref.current.getBoundingClientRect();
			setControlsHeight(rect.height);
		}
		const cb = debounce(() => {
			let rect = ref.current.getBoundingClientRect();
			setControlsHeight(rect.height);
		});
		if (setControlsHeight) {
			window.addEventListener("resize", cb);
		}

		return () => {
			if (setControlsHeight) {
				window.removeEventListener("resize", cb);
			}
		};
	}, [setControlsHeight]);

	const activeFilters = Object.values(filters)
		.filter((el) => el.value)
		.map((el) => el.fullText);

	const filterNamesText =
		activeFilters.length <= 1
			? activeFilters.join()
			: activeFilters
					.slice(0, -1)
					.join(", ")
					.concat(" & ")
					.concat(activeFilters[activeFilters.length - 1]);

	return (
		<div className={"score-breakdown-controls"} ref={ref}>
			<div className={"score-breakdown-controls__inner"}>
				<div className={"score-breakdown-controls__info"}>
					Technology scores broken down by: {filterNamesText}
				</div>
				<div className={"score-breakdown-filters"}>
					<FilterToggle
						color={colors.Grants.slug}
						value={filters.grants.value}
						updateValue={(val) =>
							updateFilters({
								...filters,
								grants: { ...filters.grants, value: val },
							})
						}>
						{filters.grants.label}
					</FilterToggle>
					<FilterToggle
						color={colors.Publications.slug}
						value={filters.publications.value}
						updateValue={(val) =>
							updateFilters({
								...filters,
								publications: { ...filters.publications, value: val },
							})
						}>
						{filters.publications.label}
					</FilterToggle>
					<FilterToggle
						color={colors.Patents.slug}
						value={filters.patents.value}
						updateValue={(val) =>
							updateFilters({
								...filters,
								patents: { ...filters.patents, value: val },
							})
						}>
						{filters.patents.label}
					</FilterToggle>
					<FilterToggle
						color={colors.Investments.slug}
						value={filters.investments.value}
						updateValue={(val) =>
							updateFilters({
								...filters,
								investments: { ...filters.investments, value: val },
							})
						}>
						{filters.investments.label}
					</FilterToggle>
				</div>
				<div className={"score-breakdown-controls__sort"}>
					<OpSelect
						options={sortOptions}
						selected={sort}
						handleChange={(prev, current) => {
							updateSort(current);
						}}
						getValue={(o) => o.key}
						getLabel={(o) => o.label}
						useIconMobile={true}
					/>
				</div>
			</div>
		</div>
	);
}
